
import SvgIcon from "@material-ui/core/SvgIcon"
import { ReactComponent as PasswordIcon } from "../fontello/icons/svg/ic_password.svg"


const Password = ({ ...props }) => (
  <SvgIcon
    component={PasswordIcon}
    viewBox="0 0 1000 1000"
    {...props}
  />
)


export default Password
